import React from 'react';
const points = ['du es leid bist, deine Freizeit für das Schreiben von Skizzen und Plänen zu opfern.', 'du nach der Arbeit direkt in die Halle kommst und keine Zeit zur Vorbereitung hattest.', 'du das Gefühl hast, dass dein Training immer gleich ist und die Spieler sich langweilen.', 'du deinem Verein ein ernstes, organisiertes und prestigeträchtiges technisches Projekt präsentieren willst.'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-111">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(37,99,235,0.08) 0%, transparent 70%)'
    }} data-id="element-112"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-113">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-12 text-center tracking-tight" data-id="element-114">
          Diese Ressource ist für dich, wenn...
        </h2>

        <div className="space-y-4" data-id="element-115">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group" data-id="element-116">
              <div className="w-8 h-8 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 group-hover:bg-check-green group-hover:border-check-green transition-colors shadow-[0_0_10px_rgba(16,185,129,0.2)]" data-id="element-117">
                <span className="text-check-green group-hover:text-white text-sm font-bold transition-colors" data-id="element-118">
                  ✓
                </span>
              </div>
              <p className="text-text-main text-lg font-medium leading-relaxed" data-id="element-119">
                {point}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}